import { useCallback } from "react";
import { useFormContext } from "react-hook-form";
import type { Paywall, PaywallPrice } from "@circle-react/types";
import type { CheckoutFormValuesProps } from "../CheckoutFormValuesProps";
import { getPaywallPrice } from "../helpers/paywallPrices";

export interface UseCheckoutSelectedPriceReturnProps {
  getSelectedPrice: () => PaywallPrice;
  setSelectedPrice: (priceId: number) => void;
  isSelectedPrice: (price: PaywallPrice) => boolean;
}

export const useCheckoutSelectedPrice = (
  paywall: Paywall,
  previewCheckout: () => void,
): UseCheckoutSelectedPriceReturnProps => {
  const { setValue, watch } = useFormContext<CheckoutFormValuesProps>();

  const setSelectedPrice = useCallback(
    (priceId: number) => {
      setValue("paywall_price_id", priceId);
      previewCheckout();
    },
    [setValue, previewCheckout],
  );

  const getSelectedPrice = useCallback(() => {
    const paywallPriceId = watch("paywall_price_id");
    return getPaywallPrice(paywall, paywallPriceId);
  }, [paywall, watch]);

  const isSelectedPrice = useCallback(
    (price: PaywallPrice) => {
      const selectedPrice = getSelectedPrice();
      return selectedPrice?.id === price.id;
    },
    [getSelectedPrice],
  );

  return { getSelectedPrice, setSelectedPrice, isSelectedPrice };
};
